import React, { Component } from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { PageController as PublicController } from "@components/public/PageController";
import { PageController as AdmController } from "@components/adm/PageController";
import PageHelper from '@model/helper/PageHelper';

export class AppRouter extends Component {
    static displayName = AppRouter.name;

    constructor(props) {
        super(props);
        
        this.helper = new PageHelper();
        this.state = {
            loading: true,
            urlList: []
        }
    }

    componentDidMount() {

        let admUrl = '/_adm';

        // /_adm/ pages do not require public url list
        if (
            window.location.pathname.startsWith(`${admUrl}/`) ||
            (window.location.pathname.startsWith(admUrl) && window.location.pathname.length === admUrl.length)
        ) {
            this.setState((prevState) => ({
                ...prevState,
                loading: false
            }));
            return;
        }

        this.helper.GetUrlList().then((urlListResponse) => {
            this.setState((prevState) => ({
                ...prevState,
                loading: false,
                urlList: urlListResponse.urlList
            }));
        });
    }

    GetLocalizedUrl = (url) => {
        return `/${url.language}/${url.url}`;
    }

    RenderPublicRoutesDynamic = () => {

        let careerUrls = this.state.urlList.filter(url => url.page === 'career');
        return <>
            <Route index element={
                <PublicController page={'home'} language={null} urlList={this.state.urlList} />
            } />

            {this.state.urlList.map(url => {
                return <Route key={url.url} path={`${this.GetLocalizedUrl(url)}`} element={
                    <PublicController page={url.page} language={url.language} urlList={this.state.urlList} />
                } />
            })}

            {careerUrls.map(url => {
                return <Route key={url.url} path={`${this.GetLocalizedUrl(url)}/:name`} element={
                    <PublicController page={'career'} language={url.language} urlList={this.state.urlList} />
                } />
            })}

            {<Route path="*" element={
                 <PublicController page={'notFound'} language={null} urlList={this.state.urlList} />
            }/>}
        </>
    }

    RenderAdmRoutes = () => {
        return <Route path="/_adm">

            <Route index element={
                <AdmController page={'dashboard'} />
            } />

            <Route path="translations" element={
                <AdmController page={'translations'} />
            } />

            <Route path="users" element={
                <AdmController page={'users'} />
            } />

            <Route path="careers" element={
                <AdmController page={'careers'} />
            } />

            <Route path="languages" element={
                <AdmController page={'languages'} />
            } />

            <Route path="pages" element={
                <AdmController page={'pages'} />
            } />

            <Route path="logs" element={
                <AdmController page={'logs'} />
            } />

            <Route path="images" element={
                <AdmController page={'images'} />
            } />

            <Route path="documents" element={
                <AdmController page={'documents'} />
            } />

            <Route path="slideShow" element={
                <AdmController page={'slideShow'} />
            } />

            <Route path="*" element={
                <AdmController page={'notFound'} />
            } />

        </Route>
    }

    render() {

        return (
            <BrowserRouter>
                <Routes>
                    <Route path="/">                
                        {this.RenderAdmRoutes()}
                        {!this.state.loading &&
                            this.RenderPublicRoutesDynamic()
                        }

                        <Route path="*" element={
                            <div className='p-4 opacity-25'>Loading ...</div>
                        } />

                    </Route>
                </Routes>
            </BrowserRouter>
        );
    }
}
